import React, { useMemo, useState } from 'react';
import DHeader from '../../pieces/DHeader';
import DText from '../../pieces/DText';
import DCode from '../../pieces/DCode';

export default function WorkflowEdvaluate() {

    return (
        <div>
            <DHeader>Evaluate the Flow</DHeader>
       
            <DText>
            Now that the Nodes, Edges, and Data Connections have been defined, you can run the workflow.


            </DText>

            <br />

            <DText>
            First, set what outputs you want to extract from the workflow using the 'set_node_outputs()' function.
            Pass in a list of App-State keys that you want to extract in the format 'Node|Action|Socket'.

            </DText>

            

            
            <DCode>
                {`simple_flow.set_node_outputs(['Model1|model1|output1'])`}
            </DCode>

            <br />

            <DText>
            Setup the inputs to the workflow as a Python dictionary.
            </DText>

            <DCode>
                {`inputs = {
    "input0": "Hello, world!"
}`}
            </DCode>

            <br />

            <DText>
            To evaluate the workflow, use the 'flow.run()' method and pass the input dictionary as its argument.
            </DText>

            <DCode>
            {`output = simple_flow.run(input_data)`}
            </DCode>

            <br />

            <DText style={{fontWeight:'bold'}}>Congratulations, you have built your first workflow.</DText>
       
        </div>
    )
}